import { render } from "./v-select.vue?vue&type=template&id=fb7643f0&scoped=true"
import script from "./v-select.vue?vue&type=script&lang=js"
export * from "./v-select.vue?vue&type=script&lang=js"

import "./v-select.vue?vue&type=style&index=0&id=fb7643f0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb7643f0"]])

export default __exports__